import { useState, useEffect } from 'react'
import ResultStats from './ResultStats.jsx'
import SearchBar from './SearchBar.jsx'
import ResultList from './ResultList.jsx'

function ResultPage() {
  // useEffect(() => {
  //   fetchSlabs()
  // }, [])

  // const fetchSlabs = async () => {
  //   const response = await fetch('slabData')

  //   const data = await response
  //   console.log(data)
  // }

  return (
    <>
      <ResultStats />
      <SearchBar />
      <ResultList />
    </>
  )
}

export default ResultPage
